// extracted by mini-css-extract-plugin
module.exports = {"container":"PatientAnswer_container__3RpcR","section":"PatientAnswer_section__UqVQ1"};